
    var dd_localisationManagerObject;

    var dd_localisationManager = function(){
      this.countryCode;
      this.active = false;
      this.initIntervalID;
      this.authorizedCountries=["CA","JP","SG","IN","HK","MY","AT","BE","BG","HR","CY","DK","EE","FI","FR","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","NZ","AU","GB","NO","TH","IE","US","PH","AE","KW","AI","AW","BM","BQ","KY","CW","FK","MS","BL","SH","PM","SX","TC","VG","VI","IS","CH","PK","SA","OM","BH","QA","MK","AZ","AL","BS","BB","BZ","DM","GD","GY","HT","KN","LC","ST","PS","TW","KR","IL","US","DE","CO","ET","MV","TT"];/*Defined where we can sell*/
      this.countriesInfos={"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BQ":"Bonaire, Sint Eustatius and Saba","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, the Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d'Ivoire","HR":"Croatia","CU":"Cuba","CW":"Curaçao","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Korea, Democratic People's Republic of","KR":"Korea, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","BL":"Saint Barthélemy","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","MF":"Saint Martin (French part)","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten (Dutch part)","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan, Province of China","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"};
    }


    dd_localisationManager.prototype.init = function(){
      var thisObject = this;

      this.market_handle = dd_market_handle;

      thisObject.countryCode = Shopify.country;
      thisObject.locationReceived();

      /*this.initIntervalID = setInterval(function(){
        if(typeof tg_ipInfos === "object" && typeof tg_ipInfos.countryCode === "string") {
          thisObject.countryCode = tg_ipInfos.countryCode;
            console.log("this.countrycode: "+thisObject.countryCode);
          clearInterval(thisObject.initIntervalID);
          thisObject.locationReceived();
          return false;
        }
      }, 400);*/
    };

    dd_localisationManager.prototype.locationReceived = function(){
      this.locationsSpecialisations();
      this.active=true;
	  //this.newProductVersionGeoHandling();
    };

    dd_localisationManager.prototype.locationsSpecialisations = function(){
      console.log("localisation specification: "+this.countryCode);
      switch(this.countryCode){
        case "CA":
          this.loc_CA();
          break;
        case "US":
          this.loc_US();
          break;
        case "FR":
          this.loc_FR();
          break;
        case "BE":
          this.loc_BE();
          break;
        case "GB":
          this.loc_GB();
          break;
        case "IE":
          this.loc_IE();
          break;
        case "JP":
          this.loc_JP();
          break;
        case "AU":
          this.loc_AU();
          break;
        case "SG":
          this.loc_SG();
          break;
        case "CH":
          this.loc_CH();
          break;
        case "BE":
          this.loc_BE();
          break;
        case "DE":
          this.loc_DE();
          break;
        case "AT":
          this.loc_AT();
          break;
        case "ES":
          this.loc_ES();
          break;
        case "IT":
          this.loc_IT();
          break;


        case "HK":
          this.loc_HK();
        break;
        case "PH":
          this.loc_PH();
        break;
        case "KP":
          this.loc_KP();
        break;
        case "KR":
          this.loc_KR();
        break;
        case "MY":
          this.loc_MY();
        break;

      }
    };
 


    /**
    *  SINGLE'S DAY COUNTRIES:     HK PH SG JP KP KR MY
    */




    /**
    * When we are in Canada
    */
    dd_localisationManager.prototype.loc_CA = function(){
      //Homepage : changing the certificates images to include a "Santé Canada" image.
      jQuery("#dd_home_certsImg_dskp").attr("src","https://cdn.shopify.com/s/files/1/0077/9042/8275/files/lgo_alld_ddctv_dskssall.png?v=1766003844");
      jQuery("#dd_home_certsImg_mobi").attr("src","https://cdn.shopify.com/s/files/1/0077/9042/8275/files/lgo_alld_ddctv_cellintaus.png?v=1765462981");






      //jQuery(".logoclrimg").attr("src","https://cdn.shopify.com/s/files/1/0077/9042/8275/files/logo_dermadry_canada.svg?v=1625150358");



      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("ca");

    };

    /**
    * When we are in the US
    */
    dd_localisationManager.prototype.loc_US = function(){
    this.amazonShowHomeButton("ca");

    };

    /**
    * When we are in France
    */
    dd_localisationManager.prototype.loc_FR = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("fr");
    };

    /**
    * When we are in Belgium
    */
    dd_localisationManager.prototype.loc_BE = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("fr");
    };

    /**
    * When we are in Great Britain (UK)
    */
    dd_localisationManager.prototype.loc_GB = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("uk");


            //$('.ddpromo1').attr('style', 'display: block !important');
            //jQuery(".ddpromo2").css("display", "none");


    };

    /**
    * When we are in Ireland
    */
    dd_localisationManager.prototype.loc_IE = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("uk");
    };

    /**
    * When we are in Japan
    */
    dd_localisationManager.prototype.loc_JP = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("jp");

      //$('.ddpromo1').attr('style', 'display: block !important');
      //jQuery(".ddpromo2").css("display", "none");

    };

    /**
    * When we are in Australia
    */
    dd_localisationManager.prototype.loc_AU = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("au");
    };
    /**
    * When we are in Singapore
    */
    dd_localisationManager.prototype.loc_SG = function(){
      //Homepage: show the amazon prime button
      this.amazonShowHomeButton("sg");

      //$('.ddpromo1').attr('style', 'display: block !important');
      //jQuery(".ddpromo2").css("display", "none");

    };
    /**
    * When we are in Switzerland
    */
    dd_localisationManager.prototype.loc_CH = function(){
      //Homepage: show the amazon prime button for france
      this.amazonShowHomeButton("fr");
    };
    /**
    * When we are in Belgium
    */
    dd_localisationManager.prototype.loc_BE = function(){
      //Homepage: show the amazon prime button for france
      this.amazonShowHomeButton("fr");
    };

    /**
    * When we are in Italy
    */
    dd_localisationManager.prototype.loc_BE = function(){
      //Homepage: show the amazon prime button for Italy
      this.amazonShowHomeButton("it");
    };

    /**
    * When we are in Allemagne
    */
    dd_localisationManager.prototype.loc_DE = function(){
      //Homepage: show the amazon prime button for Allemagne
      this.amazonShowHomeButton("de");
    };
    /**
    * When we are in Autriche
    */
    dd_localisationManager.prototype.loc_AT = function(){
      //Homepage: show the amazon prime button for Autriche
      this.amazonShowHomeButton("at");
    };
    /**
    * When we are in Spain
    */
    dd_localisationManager.prototype.loc_ES = function(){
      //Homepage: show the amazon prime button for Spain
      this.amazonShowHomeButton("es");
    };

    /**
    * When we are in Italy
    */
    dd_localisationManager.prototype.loc_IT = function(){
      //Homepage: show the amazon prime button for Italy
      this.amazonShowHomeButton("it");
    };

    /*
     When we are in Single's Day countries
    */

    /*
     dd_localisationManager.prototype.loc_HK = function(){
      $('.ddpromo1').attr('style', 'display: block !important');
       jQuery(".ddpromo2").css("display", "none");
     };
     dd_localisationManager.prototype.loc_PH = function(){
       $('.ddpromo1').attr('style', 'display: block !important');
       jQuery(".ddpromo2").css("display", "none");
     };
     dd_localisationManager.prototype.loc_KP = function(){
       $('.ddpromo1').attr('style', 'display: block !important');
       jQuery(".ddpromo2").css("display", "none");
     };
     dd_localisationManager.prototype.loc_KR = function(){
       $('.ddpromo1').attr('style', 'display: block !important');
       jQuery(".ddpromo2").css("display", "none");
     };
     dd_localisationManager.prototype.loc_MY = function(){
       $('.ddpromo1').attr('style', 'display: block !important');
       jQuery(".ddpromo2").css("display", "none");
     };

    */



	/**
	* New product version Handling (bunch of countries so bundled here)
	*/

	dd_localisationManager.prototype.newProductVersionGeoHandling = function(){
		if(typeof vrsn_set === "string"){return false;} //Already set. Do not attempt to change again

		const old_version_countries = ["AT","BE","FR","GF","PF","TF","DE","IE","IT","LU","MT","NL","ES","GB","CS","LI","CH","MC"];

		if(old_version_countries.includes(this.countryCode)){
			jQuery("body").attr("data-vrsn","0");
		}
	};



    /**
    * Amazon btn
    */
    dd_localisationManager.prototype.amazonShowHomeButton = function(lang){
      console.log("amazonShowHomeButton : "+lang);
      jQuery(".zn-bt-amazonRg[data-rg!='"+lang+"']").remove();
      jQuery(".zn-bt-amazonRg[data-rg='"+lang+"']").hide();
      jQuery(".zn-bt-amazonRg[data-rg='"+lang+"']").removeClass("sty_dspnone");
      jQuery(".zn-bt-amazonRg[data-rg='"+lang+"']").fadeIn(200);
    };

    //Declare the dd_localisationManager
    dd_localisationManagerObject = new dd_localisationManager();

    jQuery(document).ready(function(){
        //Initiate the events (buttons ...)
        dd_localisationManagerObject.init();
    });

